import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useSSO, logo, useMobileLogin } from 'config';
import pallet from 'constants/colors';

import { loginStep } from '../actions/account/login';
import logoutUser from '../actions/account/logout';
import Login from '../components/account/Login';
import ForgotPassword from '../components/account/ForgotPassword';
import TwoFactor from '../components/account/TwoFactor';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: 'white',
    height: '100vh',
    marginTop: -64,
  },
  logo: {
    maxHeight: 150,
    maxWidth: 220,
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 800,
    marginTop: '6%',
    width: '100%',
  },
  art1: {
    bottom: 0,
    right: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    borderBottom: '40vw solid rgb(35, 95, 167)',
    borderLeft: '55vw solid transparent',
    opacity: 0.3,
    borderBottomColor: pallet.loginColor,
  },
  art2: {
    bottom: 0,
    right: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    borderBottom: '25vw solid rgb(35, 95, 167)',
    borderLeft: '60vw solid transparent',
    opacity: 0.4,
    borderBottomColor: pallet.loginColor,
  },
  art3: {
    bottom: 0,
    right: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    borderBottom: '15vw solid rgb(35, 95, 167)',
    borderLeft: '100vw solid transparent',
    opacity: 0.7,
    borderBottomColor: pallet.loginColor,
  },
};

class Account extends Component {

  componentWillMount() {
    const { dispatch, location: { query: { logout } }, isAuthenticated } = this.props;
    if (logout && isAuthenticated) {
      dispatch(logoutUser());
    }
    if (useSSO) {
      dispatch(loginStep('sso'));
    } else if (useMobileLogin) {
      dispatch(loginStep('mobile'));
    } else {
      dispatch(loginStep('initial'));
    }
  }
  renderLogin() {
    switch (this.props.step) {
      case 'forgotPassword':
        return (<ForgotPassword />);
      case 'sso':
        return (<Login sso />);
      case 'mobile':
        return (<TwoFactor />);
      default:
        return (<Login />);
    }
  }

  render() {
    return (
      /*
      <Row style={{ margin: 0 }}>
        <Col xs={12} smOffset={2} sm={8} mdOffset={3} md={6} lgOffset={4} lg={4}>
          <div style={styles.logoContainer}><img style={styles.logo} src={logo} alt="logo" /></div>
          {this.renderLogin()}
        </Col>
      </Row>
      */
      <div style={styles.container}>
        <div style={styles.logoContainer}>
          <img style={styles.logo} src={logo} alt="logo" />
        </div>
        {this.renderLogin()}
        <div style={styles.art1} />
        <div style={styles.art2} />
        <div style={styles.art3} />
      </div>
    );
  }
}

Account.propTypes = {
  isAuthenticated: PropTypes.bool,
  step: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

Account.contextTypes = {
  router: PropTypes.object,
};

function mapStateToProps(state) {
  const isAuthenticated = state.loginReducer.isAuthenticated;
  const step = state.loginReducer.step;
  return { isAuthenticated, step };
}

export default connect(mapStateToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/Account.js